<template>
    <div class="LibraryTableComponent dataTables">

        <div v-show="isData" :id="id"></div>

        <LoaderComponent v-show="!isData"></LoaderComponent>

    </div>
</template>
<script>
import LoaderComponent from "@/components/shared/LoaderComponent"
import { mapGetters } from 'vuex'

import $ from 'jquery';
import dt from 'datatables.net-bs4';


export default {
    name: "LibraryTableComponent",
    props: {
        lang: Object,
        reloadTable: Boolean,
        data: Object
    },
    components: {

        LoaderComponent
    },
    data() {
        return {
            name: "LibraryTableComponent",
            mainTable: "",
            footprints: [],

            searchTableInput: ""
        }
    },
    computed: {
        ...mapGetters({

            appConf: 'appConf'

        }),
        id() {

            return "place_" + this._uid
        },
        isData() {
            return this.footprints.length >= 0
        },
        filteredData() {
            // var a = this.mainTable
            // .column( 4 )
            // .data()
            // .filter( function ( value, index ) {
            //   console.log(value)
            //   console.log(index)
            //     return value > 20 ? true : false;
            // } );

            // return a
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        }
    },
    created() {


        this.getFootprints()


    },
    watch: {
        reloadTable: function () {

            this.getFootprints();
        }
    },
    updated() {


    },
    methods: {
        
        
        getFootprints() {
            let vue = this;

            let obj = {
                propertyId: this.data.propertyId
            }

            this.$store.dispatch(this.$store.getters.sectionPrefix + '_getGenericLibraries', obj)
                .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {

                        vue.footprints = result.data;

                        vue.buildTable();
                    }

                })
        },
        buildTable() {



            let tableplace = document.getElementById(this.id);
            if (tableplace == null) {
                return
            }
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            let table = document.createElement("table");
            table.setAttribute("id", "t_" + this.id);
            table.setAttribute("class", "table table-striped table-bordered");
            table.setAttribute("style", "width:100%;");
            tableplace.appendChild(table)

            let tr = document.createElement("tr");
            tr.setAttribute("class", "cellHeader");
            let thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            let _vue = this;

            let columns = [
                {
                    name: "Id",
                    alignInColumn: "left",

                },
                // {
                //   name: this.lang.table_header_Image,
                //   alignInColumn: "left",

                // },
                {
                    name: this.lang.table_header_Name,
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Status,
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Action,
                    alignInColumn: "left",

                },


            ]

            let cols = [
                
                { "data": "revisionId" },
                { "data": "name" },
                { "data": "prototype" },


            ]


            let columnDefs = [];
            let len = columns.length;
            let trigImage = false;
            for (let i = 0; i < len; i++) {
                let widthCol = "30%";
                // if (i == 1){
                //   widthCol = "44"
                // }
                if (i == 1) {
                    widthCol = "70%"
                }

                let classname = '_dt-body-' + columns[i].alignInColumn;

                const el = {
                    targets: i,
                    width: widthCol,
                    className: classname,

                    render: function (data, type, row, meta) {
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                            data.display = $.fn.dataTable.render.text().display(data.display);
                        }


                        if (meta.col == 0) {

                            return data;

                        }

                        if (meta.col == 1) {


                            return data;
                        }
                        if (meta.col == 2) {

                            if (data == true) {
                                return "<b-badge class='badge badge-warning '>" + _vue.lang.tag_Prototype + "</b-badge>";
                            }
                            return "";
                        }
                        if (meta.col == 3) {
                            let str = "<button  class=\"btn btn-secondary btn-sm btn-" + _vue.variant + " button-action-select\" id=\"button_select__" + row.revisionId + "\" >" + _vue.lang.button_Select + "</button>";
                            
                            return str;
                        }


                    },


                }

                columnDefs.push(el);



                let th = document.createElement("th");
                tr.appendChild(th);
                var br = document.createElement("br");
                th.appendChild(br);

                let tx = document.createTextNode(columns[i].name)
                th.appendChild(tx);

            }


            const json = {};
            json.paging = true;
            json.info = true;
            json.dom = 'f<t>ip';
            json.data = this.footprints;
            json.myColumnFormats = columns;
            json.select = false;
            json.order = [[1, "asc"]];
            json.lengthMenu = [8];
            json.columns = cols;

            json.columnDefs = columnDefs;
            json.initComplete = function () {



            }




            if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
                this.mainTable.destroy();

            }



            this.mainTable = $('#t_' + this.id).DataTable(json);

            this.mainTable.columns.adjust().draw();

            //hide first column in table
            this.mainTable.column(0).visible(false);

            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }
            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm");


            $("#t_" + this.id + ' tbody').on('click', 'button', function (e) {



                var data = _vue.mainTable.row($(this).parents('tr')).data();


                let posSelect = e.target.id.indexOf("select");
                if (posSelect > -1) {
                    for (let i = 0, lei = _vue.footprints.length; i < lei; i++) {
                        if (_vue.footprints[i].revisionId == data.revisionId) {

                            _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_addSelectedFootprint", _vue.footprints[i]);
                            break;
                        }
                    }
                }
                let posDelete = e.target.id.indexOf("delete")
                if (posDelete > -1) {

                    const obj = {
                        revisionId: data.revisionId
                    }

                    _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteFootprint", obj)
                        .then((result) => {

                            console.log(result)
                            if (result.status == "OK") {

                                _vue.getFootprints()
                            }
                        })


                }

            });

            this.mainTable.draw();

        }

    }


}
</script>
<style lang="scss">
// @import "./../../scss/_theme.scss";
// @import "./../../scss/_tables.scss";

.LibraryTableComponent {
    table {
        font-size: 0.75rem;
        padding: 0px !important;
        width: 100% !important;
        margin-right: 10px;

    }

    table th {
        padding: 2px !important;
        min-width: 200px;
    }

    table th select {
        width: 100% !important;

    }

    table td {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;

    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
        position: absolute;
        top: 20px;
        left: 50%;
        width: 100%;
        height: 20px;
        margin-left: -50%;
        margin-top: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 1em;

    }

    .dataTables_filter {
        font-size: 10px;
        width: 210px;
    }

    .searcher {
        float: left;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    table {
        .btn {
            padding: 0.15rem 0.5rem;
            margin: 2px;
        }

        .image-library {
            max-width: 40px;
            border-radius: 2px;
            margin-top: 3px;
            margin-right: 3px;
            margin-bottom: 3px;
            background-color: white;
            padding: 2px;
        }

        .badge {
            margin: 3px;
        }
    }
}</style>



// WEBPACK FOOTER //
// src/components/shared/LibraryTableComponent.vue